import { defaultState } from './state'

import {
  SET,
  EMPTY,
  LOAD,
  LOADING,
  ASSIGNMENTS,
  COLLABORATIONS,
  LOADINGASSIGNMENTS,
  LOADINGCOLLABORATIONS,
  RESET,
} from './mutation-types'

export default {
  [SET](state, data) {
    for (let field in data) {
      if (field in data && field in state) {
        state[field] = data[field]
      }
    }
  },
  [LOADING](state, bool) {
    state.loading = bool
  },
  [LOAD](state, questions) {
    state.questions = questions || []
  },
  [EMPTY](state) {
    state.questions = []
  },
  [ASSIGNMENTS](state, { questionId, assignments }) {
    state.assignments[questionId] = assignments || []
  },
  [COLLABORATIONS](state, { questionId, collaborations }) {
    state.collaborations[questionId] = collaborations || []
  },
  [LOADINGASSIGNMENTS](state, loading) {
    state.loadingAssignments = loading
  },
  [LOADINGCOLLABORATIONS](state, loading) {
    state.loadingCollaborations = loading
  },
  [RESET](state) {
    Object.assign(state, defaultState())
  },
}
